// src/config.js
const config = {
  apiUrl: "https://api.serchuvasoftware.com",
  // apiUrl: "https://localhost:7160",
};

export default config;